import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const setOfDayTypesApiRoutes = {
    list: apiBusSchedBaseURL + "setofdaytypes/",
    listFull: apiBusSchedBaseURL + "setofdaytypes/full/",
};

export class SetOfDayTypesAPI {
    static list() {
        const url = setOfDayTypesApiRoutes.list;
        
        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listFull() {
        const url = setOfDayTypesApiRoutes.listFull;
        
        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/bussched/SetOfDayTypesAPI.js